import { defineComponent, toRefs, watch, h } from '@vue/composition-api';
import { withInstall } from '../util/index.js';
import Button from '../button/index.js';
import { Config } from '../config/index.js';

var Toast = defineComponent({
  name: 'm-toast',
  props: {
    icon: {
      type: [Function, String],
      "default": function _default() {
        return null;
      }
    },
    text: {
      type: String,
      "default": ''
    },
    duration: {
      type: Number,
      "default": 1500
    },
    showCancel: {
      type: Boolean,
      "default": false
    },
    cancelText: {
      type: String,
      "default": ''
    },
    visible: {
      type: Boolean,
      "default": false
    },
    position: {
      type: String,
      "default": 'center'
    },
    lineClamp: {
      type: Boolean,
      "default": true
    }
  },
  slots: ['icon'],
  emits: ['cancel', 'icon'],
  setup: function setup(props, context) {
    var propsRef = toRefs(props);

    var onClose = function onClose() {
      context.emit('cancel');
    };

    var timer; // toast展示时，开始计时

    watch(function () {
      return props.visible;
    }, function () {
      if (props.visible && props.duration > 0 && !timer) {
        timer = setTimeout(function () {
          onClose();
          timer = 0;
        }, props.duration);
      }
    }, {
      immediate: true
    }); // 监听定时器配置变化

    watch(function () {
      return props.duration;
    }, function () {
      if (timer) {
        clearTimeout(timer);

        if (props.duration > 0) {
          timer = setTimeout(function () {
            onClose();
            timer = 0;
          }, props.duration);
        }
      }
    });
    return function () {
      var locales = Config.getLocale();
      var positionClass = props.position === 'top' || props.position === 'center' ? "m-toast-position-".concat(props.position) : '';
      var positionStyle = positionClass ? {} : {
        top: props.position
      };
      var icon;

      if (typeof props.icon === 'string') {
        icon = h("img", {
          "attrs": {
            "src": props.icon
          }
        });
      }

      if (typeof props.icon === 'function') {
        var _props$icon;

        icon = (_props$icon = props.icon) === null || _props$icon === void 0 ? void 0 : _props$icon.call(props);
      }

      if (context.slots.icon) {
        icon = context.slots.icon();
      }

      var iconClass = icon ? 'm-toast-icon' : 'm-toast-text';
      return h("transition", {
        "attrs": {
          "name": "m-ani-fade",
          "appear": true
        }
      }, [propsRef.visible.value && h("div", {
        "class": "m-toast ".concat(iconClass, " ").concat(positionClass),
        "style": positionStyle
      }, [icon && h("div", {
        "class": "m-toast__icon",
        "on": {
          "click": function click() {
            return context.emit('icon');
          }
        }
      }, [icon]), h("div", {
        "class": "m-toast__text"
      }, [h("div", {
        "class": "m-toast__text-wrap"
      }, [h("div", {
        "class": {
          'webkit-box': props.lineClamp
        }
      }, [propsRef.text.value])])]), propsRef.showCancel.value && h("div", {
        "class": "m-toast__cancel"
      }, [h(Button, {
        "attrs": {
          "size": "small"
        },
        "on": {
          "click": onClose
        }
      }, [props.cancelText || locales.Toast.cancelText])])])]);
    };
  }
});
withInstall(Toast);

export { Toast as default };
//# sourceMappingURL=toast.js.map
